import React, {Fragment, useState} from "react";
import {
    Button, Card, CardBody, Col, FormGroup, Input, Label, Row, Popover, PopoverBody, PopoverHeader
} from "reactstrap";
import {Link} from "react-router-dom";
import ReactPaginate from "react-paginate";
import {NotFoundData} from "../../../../constant";
import ProductView from "./productView";
import ProductAIForm from "./productAIForm";
import ManageSignatureDetailsModal from "./manageSignatureDetailsModal";
import ManageSizeColourMediaModal from "./manageSizeColourMediaModal";
import ManageHowToStyleVideoModal from "./manageHowToStyleVideoModal";
import ManageWearItToModal from "./manageWearItToModal";
import ManageFabricCareModal from "./manageFabricCareModal";
import ManageQuestionsAnswersModal from "./manageQuestionsAnswersModal";
import ManageSustainabilityImagesModal from "./manageSustainabilityImagesModal";
import ManageReviewMediaModal from "./manageReviewMediaModal";
import ProductActionMenuModal from "./productActionMenuModal";
import {useDispatch, useSelector} from "react-redux";
import {setProductAIDialog, setProductDialog, setProductFilter} from "../../store/prodcutSlice";
import {getProductRibbonColor} from "./../../../../utils/common"

const PopoverBasicItem = (props) => {
    const { id, btntext, Popoverbody, count } = props;
    const [popover, setPopover] = useState(false);
    const Toggle = () => setPopover(!popover);
    return (
      <>
        <span style={{ cursor: "pointer", marginLeft: 5, color: "#000000", fontSize: "1rem" }} className="example-popover" id={"Popover-" + id}>
          {btntext} <span style={{ backgroundColor: '#9c959585', color: 'black', width: '30px', height: '30px', borderRadius: '50%', fontWeight: 500, fontSize: '0.7rem', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>{`+${count}`}</span>
        </span>
  
        <Popover placement="top" isOpen={popover} target={"Popover-" + id} toggle={Toggle} trigger="hover">
          <PopoverBody>{Popoverbody}</PopoverBody>
        </Popover>
      </>
    );
};

const CardListing = (props) => {

    const {
        data,
        totalCount,
        pageChange,
        currentPage,
        productState,
        history,
        onPageSizeChange,
        selectProductRef,
        selectedProductIds,
        setselectedProductIds,
        hideCheckbox
    } = props;

    const authData =  useSelector(({authReducer}) => authReducer);
    const userState =  authData.data;
    const currentUser = userState.user;
    // Same permission that gates the product-management CRUD actions on this listing
    // (Create Product / Publish Product / Sync GTN Number are its narrower child
    // permissions) and that the product-signature-details backend routes enforce.
    const hasProductManagementPermission = userState.user.permission.includes("All Products");

    const [actionMenuItem, setActionMenuItem] = useState(null);
    const [signatureDetailsProduct, setSignatureDetailsProduct] = useState(null);
    const [signatureDetailsModalOpen, setSignatureDetailsModalOpen] = useState(false);
    const [sizeColourMediaProduct, setSizeColourMediaProduct] = useState(null);
    const [sizeColourMediaModalOpen, setSizeColourMediaModalOpen] = useState(false);
    const [howToStyleVideoProduct, setHowToStyleVideoProduct] = useState(null);
    const [howToStyleVideoModalOpen, setHowToStyleVideoModalOpen] = useState(false);
    const [wearItToProduct, setWearItToProduct] = useState(null);
    const [wearItToModalOpen, setWearItToModalOpen] = useState(false);
    const [fabricCareProduct, setFabricCareProduct] = useState(null);
    const [fabricCareModalOpen, setFabricCareModalOpen] = useState(false);
    const [qaProduct, setQaProduct] = useState(null);
    const [qaModalOpen, setQaModalOpen] = useState(false);
    const [sustainabilityProduct, setSustainabilityProduct] = useState(null);
    const [sustainabilityModalOpen, setSustainabilityModalOpen] = useState(false);
    const [reviewMediaProduct, setReviewMediaProduct] = useState(null);
    const [reviewMediaModalOpen, setReviewMediaModalOpen] = useState(false);

    const openActionMenu = (item) => {
        setActionMenuItem(item);
    };

    const openSignatureDetails = (item) => {
        // Re-assigning productId while the modal is already open re-triggers its own
        // [open, productId] effect, which fully clears stale entries before refetching —
        // so switching rows while open re-scopes cleanly with no extra logic needed here.
        setSignatureDetailsProduct({id: item.id, code: item.code, colors: item.colors});
        setSignatureDetailsModalOpen(true);
    };

    const openSizeColourMedia = (item) => {
        // Re-assigning productId while the modal is already open re-triggers its own
        // [open, productId] effect, which fully clears stale entries before refetching —
        // so switching rows while open re-scopes cleanly with no extra logic needed here.
        setSizeColourMediaProduct({id: item.id, code: item.code, colors: item.colors});
        setSizeColourMediaModalOpen(true);
    };

    const openHowToStyleVideo = (item) => {
        // Re-assigning productId while the modal is already open re-triggers its own
        // [open, productId] effect, which fully clears stale state before refetching —
        // so switching rows while open re-scopes cleanly with no extra logic needed here.
        setHowToStyleVideoProduct({id: item.id, code: item.code, colors: item.colors});
        setHowToStyleVideoModalOpen(true);
    };

    const openWearItTo = (item) => {
        // Re-assigning productId while the modal is already open re-triggers its own
        // [open, productId] effect, which fully clears stale entries before refetching —
        // so switching rows while open re-scopes cleanly with no extra logic needed here.
        setWearItToProduct({id: item.id, code: item.code, colors: item.colors});
        setWearItToModalOpen(true);
    };

    const openFabricCare = (item) => {
        setFabricCareProduct({id: item.id, code: item.code, colors: item.colors});
        setFabricCareModalOpen(true);
    };

    const openQuestionsAnswers = (item) => {
        setQaProduct({id: item.id, code: item.code, colors: item.colors});
        setQaModalOpen(true);
    };

    const openSustainabilityImages = (item) => {
        setSustainabilityProduct({id: item.id, code: item.code, colors: item.colors});
        setSustainabilityModalOpen(true);
    };

    const openReviewMedia = (item) => {
        setReviewMediaProduct({id: item.id, code: item.code, colors: item.colors});
        setReviewMediaModalOpen(true);
    };

    const dispatch = useDispatch();
    const singleProductChange = (e, id) => {
        const selectedProductArray = [...selectedProductIds];
        let productIndex = selectedProductArray.findIndex(aItem => aItem === id);
        if (productIndex != -1) {
            if (!e.target.checked) {
                selectedProductArray.splice(productIndex, 1);
            }
        } else {
            selectedProductArray.push(id);
        }
        setselectedProductIds(selectedProductArray);
    }
  
      function handleColor(item) {
        if (!item.colors || !Array.isArray(item.colors)) {
          return;
        }
        
        if (item.colors.length > 1) {
            const validColors = item.colors.filter(Boolean); 
            const finalColours = validColors.slice(1).join(" | ");
            const countExcludingFirst = Math.max(validColors.length - 1, 0);
      
          return (
            <>
              {`Color : ${item.colors[0]}`}{" "}
              <PopoverBasicItem id={item.id} Popoverbody={finalColours} count={countExcludingFirst}/>
            </>
          );
        } else if (item.colors.length === 1) {
          return (
            <span
              style={{
                fontFamily: "inherit",
                fontSize: "0.9rem",
                fontWeight: "inherit",
                lineHeight: "inherit",
                color: "inherit",
              }}
            >
              {`Color : ${item.colors[0]}`}
            </span>
          );
        } else {
          return;
        }
      }
      

    return (
        <>{data.length < 1 ? <div className="search-not-found text-center">
                <div>
                    <img className="img-fluid second-search" src={require('../../../../assets/images/search-not-found.png')}
                         alt=""/>
                    <p>{NotFoundData}</p>
                </div>
            </div> :
            <Row className="gridRow">
                {data.map((item, i) =>
                    <div className={`col-sm-${productState.filter.gridColumnNo}  col-grid-box`} key={i}>
                        <Card>
                            <div className="search-not-found text-center">
                                <div>
                                    <img className="img-fluid second-search" alt=""/>
                                    <p></p>
                                </div>
                            </div>
                            <div className="product-box">
                                <div className="product-img">

                                                        <span
                                                            className={`ribbon  ${getProductRibbonColor(item.status)}`}>
                      {item.brand}
                            </span>
                            {item.is_test === 1 && <span className="ribbon-test ribbon-danger" style={{fontSize :"0.7rem"}}>Test Product</span>}
                                    <div className={`image-crop-center card-height-${productState.filter.gridColumnNo}`}>
                                        <img className="img-fluid scale-image-8" src={item.url} alt=""/>
                                    </div>
                                    <div className="product-hover">
                                        <ul>
                                            { currentUser.role.name!=="Seller" && currentUser.permission.includes("AI Form") && (
                                            <li 
                                                onClick={() => {
                                                    let obj = {props: {isOpen: true}, data: {id: item.id}};
                                                    dispatch(setProductAIDialog(obj))
                                                }}>
                                                <Button color="default" data-toggle="modal">
                                                    <i className="icofont icofont-brainstorming"></i>
                                                </Button>
                                            </li>
                                            )}
                                            <li 
                                                onClick={() => {
                                                    let obj = {props: {isOpen: true}, data: {id: item.id}};
                                                    dispatch(setProductDialog(obj))
                                                }}>
                                                <Button color="default" data-toggle="modal">
                                                    <i className="icon-eye"></i>
                                                </Button>
                                            </li>
                                            <li>
                                                <Link to={`${process.env.PUBLIC_URL}/product/${item.id}/edit`}>
                                                    <i className="icon-pencil"></i>
                                                </Link>
                                            </li>
                                            {hasProductManagementPermission && (
                                            <li onClick={(e) => {e.stopPropagation(); openActionMenu(item);}}>
                                                <span style={{cursor: "pointer", display: "inline-block"}}>
                                                    <i className="icon-more"></i>
                                                </span>
                                            </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                                <div className="product-details">
                                    <Row>
                                        <Col md={12}>
                                            <h4 onClick={() => {
                                            }} style={{
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden',
                                                width: '100%',
                                                whiteSpace: 'nowrap'
                                            }} className="font-primary"><a style={{textDecoration:'none', color:'#3E4A56'}} href={item.product_url} target="_blank">{item.name} </a></h4>
                                        </Col>
                                    </Row>
                                    <Row className="mt-1">
                                        <Col md={9}>
                                            <p style={{
                                                textOverflow: 'ellipsis',
                                                overflow: 'hidden',
                                                width: '100%',
                                                whiteSpace: 'nowrap',
                                                marginBottom : 0
                                            }}>{item.code}</p>
                                            <p style={{marginTop : 0}}>{handleColor(item)}</p>
                                        </Col>
                                        <Col md={3} className="text-right">
                                            {(!hideCheckbox ? 
                                            <input ref={(ref) => {
                                                selectProductRef.current[item.id] = ref;
                                            }} type="checkbox" onChange={(e) => {

                                                singleProductChange(e, item.id)
                                            }}
                                                   checked={selectedProductIds.findIndex(aItem => aItem === item.id) != -1 ? true : false}/>
                                            : <></>
                                            )}
                                        </Col>

                                    </Row>


                                    <Row className="">
                                        <Col md={productState.filter.gridColumnNo == 2 ? 12 : 6}>
                                            <Row>
                                                <Col md={12}>
                                                    <div className="product-price">
                                                        {'Stocks : '} {item.stock}

                                                    </div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                    {item.selling_type  != 0 &&<div className="f-12">
                                                        {item.selling_type !=3 && <> {'Pack : '} {item.pack_stock}  </>}
                                                        {item.selling_type ==1 && <> | </>}
                                                        {item.selling_type !=2 && <>{'Single : '} {item.single_Stock}</>}
                                                    </div>}
                                                </Col>
                                            </Row>


                                        </Col>
                                        <Col md={productState.filter.gridColumnNo == 2 ? 12 : 6}>
                                            <div className="product-price text-right">
                                                {item.sale_price ? <>
                                                    <del> {item.price ? '£' + item.price : ""}</del>
                                                    <span
                                                        className="ml-1"> {item.sale_price ? '£' + item.sale_price : ""}</span>
                                                </> : <>{item.price ? '£' + item.price : ""}</>}

                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <div style={{fontSize: 12}}>


                                            </div>
                                        </Col>
                                    </Row>

                                </div>
                            </div>
                        </Card>
                    </div>)
                }
            </Row>}
            <Row>
                <Col md={12}>
                    <div style={{display: "inline-flex", float: "right"}}>
                        <div className="mr-1">
                            <Input type="select" name="select" onChange={onPageSizeChange}
                                   className="form-control digits" defaultValue={productState.filter.pageSize}>
                                <option value="12">12</option>
                                <option value="24">24</option>
                                <option value="48">48</option>
                                <option value="96">96</option>
                            </Input>
                        </div>
                        <div>
                            <ReactPaginate
                                className="pagination"
                                activeClassName="pagination-active"
                                breakLabel="..."
                                nextLabel="next >"
                                onPageChange={pageChange}
                                pageRangeDisplayed={5}
                                pageCount={totalCount}
                                forcePage={currentPage}
                                previousLabel="< previous"
                                renderOnZeroPageCount={null}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
            <ProductView></ProductView>
            <ProductAIForm></ProductAIForm>
            <ManageSignatureDetailsModal
                open={signatureDetailsModalOpen}
                onClose={() => setSignatureDetailsModalOpen(false)}
                productId={signatureDetailsProduct?.id}
                productCode={signatureDetailsProduct?.code}
                productColour={signatureDetailsProduct?.colors}
            />
            <ManageSizeColourMediaModal
                open={sizeColourMediaModalOpen}
                onClose={() => setSizeColourMediaModalOpen(false)}
                productId={sizeColourMediaProduct?.id}
                productCode={sizeColourMediaProduct?.code}
                productColour={sizeColourMediaProduct?.colors}
            />
            <ManageHowToStyleVideoModal
                open={howToStyleVideoModalOpen}
                onClose={() => setHowToStyleVideoModalOpen(false)}
                productId={howToStyleVideoProduct?.id}
                productCode={howToStyleVideoProduct?.code}
                productColour={howToStyleVideoProduct?.colors}
            />
            <ManageWearItToModal
                open={wearItToModalOpen}
                onClose={() => setWearItToModalOpen(false)}
                productId={wearItToProduct?.id}
                productCode={wearItToProduct?.code}
                productColour={wearItToProduct?.colors}
            />
            <ManageFabricCareModal
                open={fabricCareModalOpen}
                onClose={() => setFabricCareModalOpen(false)}
                productId={fabricCareProduct?.id}
                productCode={fabricCareProduct?.code}
                productColour={fabricCareProduct?.colors}
            />
            <ManageQuestionsAnswersModal
                open={qaModalOpen}
                onClose={() => setQaModalOpen(false)}
                productId={qaProduct?.id}
                productCode={qaProduct?.code}
                productColour={qaProduct?.colors}
            />
            <ManageSustainabilityImagesModal
                open={sustainabilityModalOpen}
                onClose={() => setSustainabilityModalOpen(false)}
                productId={sustainabilityProduct?.id}
                productCode={sustainabilityProduct?.code}
                productColour={sustainabilityProduct?.colors}
            />
            <ManageReviewMediaModal
                open={reviewMediaModalOpen}
                onClose={() => setReviewMediaModalOpen(false)}
                productId={reviewMediaProduct?.id}
                productCode={reviewMediaProduct?.code}
                productColour={reviewMediaProduct?.colors}
            />
            <ProductActionMenuModal
                open={!!actionMenuItem}
                onClose={() => setActionMenuItem(null)}
                actions={actionMenuItem ? [
                    {icon: "icon-image", label: "Signature Details", onClick: () => openSignatureDetails(actionMenuItem)},
                    {icon: "icon-image", label: "Size-wise Fit Guide Media", onClick: () => openSizeColourMedia(actionMenuItem)},
                    {icon: "icon-video", label: "How to Style Video", onClick: () => openHowToStyleVideo(actionMenuItem)},
                    {icon: "icon-heart", label: "Wear It To", onClick: () => openWearItTo(actionMenuItem)},
                    {icon: "icon-tag", label: "Fabric & Care", onClick: () => openFabricCare(actionMenuItem)},
                    {icon: "icon-help", label: "Questions & Answers", onClick: () => openQuestionsAnswers(actionMenuItem)},
                    {icon: "icon-world", label: "Sustainability", onClick: () => openSustainabilityImages(actionMenuItem)},
                    {icon: "icon-star", label: "Real Reviews, Real People", onClick: () => openReviewMedia(actionMenuItem)},
                ] : []}
            />
        </>);

}
export default CardListing;